var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnTrackStatusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12C7.1712 12 7.34039 11.9914 7.50715 11.9746L5.59916 6.88662C5.46147 6.51944 5.5511 6.10567 5.82838 5.82838C6.10567 5.5511 6.51944 5.46147 6.88661 5.59916L11.9746 7.50716C11.9914 7.34039 12 7.1712 12 7C12 4.23858 9.76142 2 7 2ZM13.8929 8.22652C13.9633 7.82829 14 7.41843 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C7.41843 14 7.82829 13.9633 8.22652 13.8929L9.12524 16.2895C9.26865 16.6719 9.6302 16.9287 10.0385 16.9381C10.4468 16.9475 10.8198 16.7077 10.9807 16.3323L12.5862 12.5862L16.3323 10.9807C16.7077 10.8198 16.9475 10.4468 16.9381 10.0385C16.9287 9.6302 16.6719 9.26865 16.2895 9.12524L13.8929 8.22652Z",
    fill: "#5774FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnTrackStatusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/on-track-status-icon.dda338738365cdff7180fd81af8c31c1.svg";